import { useMutation } from '@fv/client-core'
import type { ApplicationType } from '@fv/models'
import type { ViewAsRequest, ViewAsResponse } from '@fv/models/admin'

import { adminFetch } from '@/utils'

const postViewAs = (body: ViewAsRequest) =>
  adminFetch<ViewAsResponse>(`/register/view-as-carrier`, {
    method: 'POST',
    body,
  })
export const useViewAsUser = (app: ApplicationType) => {
  return useMutation({
    mutationFn: ({ userId }: Pick<ViewAsRequest, 'userId'>) =>
      postViewAs({
        userId,
        application: app,
      }),
  })
}
